import { LongTextWrapper } from '@Styled/utilities';
import styled from 'styled-components';
import { TableCell } from '@mui/material';
const WrappedTableCell = styled(TableCell)`
	${LongTextWrapper}
`;

export { WrappedTableCell };

